/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const SendMoney = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        d="M17 2V9.75H15.5V3.5H3.5V20.5H15.5V14.25H17V22H2V2H17ZM19.227 7.22703L24 12L19.227 16.773L18.1664 15.7123L21.1293 12.7493L14 12.75V11.25L21.1283 11.2493L18.1664 8.28769L19.227 7.22703ZM10.1456 7.5V8.40443C11.3882 8.58139 12.2132 9.34819 12.2947 10.4787H10.9503C10.8586 9.9577 10.3697 9.52515 9.58546 9.52515C8.86232 9.52515 8.43454 9.81024 8.43454 10.3018C8.43454 10.7343 8.76047 10.9408 9.25954 11.0784L10.4614 11.4028C11.4901 11.6879 12.366 12.1598 12.366 13.5263C12.366 14.6568 11.5105 15.4335 10.1456 15.5809V16.564H9.00491V15.5514C7.72159 15.3351 6.83548 14.4405 6.754 13.1429H8.09844C8.15955 13.89 8.82158 14.4602 9.65676 14.4602C10.441 14.4602 10.9808 14.0965 10.9808 13.5558C10.9808 13.0741 10.604 12.7988 10.0947 12.6612L8.89287 12.3368C7.88455 12.0615 7.03918 11.5601 7.03918 10.3116C7.03918 9.32853 7.83362 8.59122 9.00491 8.40443V7.5H10.1456Z"
                        fill={color}
                    />
                </svg>
        );
    };
